// extracted by mini-css-extract-plugin
module.exports = {"Container":"IconContainer_Container__3ko4U","Icon":"IconContainer_Icon__1uvD1","Title":"IconContainer_Title__3dz5A","Children":"IconContainer_Children__X8VYx"};